<template>
  <div class="terminal-mini">
    <div class="w1200 pt96 pb64 center">
      <div class="lz-title1 mb8">小程序课堂</div>
      <div class="T6 EC3 mb64 lz-desc2">给每位知识服务者都配上专属小程序</div>
      <div class="lz-img">
        <img :src="require('@/assets/images/terminalPic4.png')" />
      </div>
    </div>
    <div class="lz-modules1 w1200 pt96">
      <div class="lz-title1">
        从获客、复购到教学，用<br
          v-if="$store.state.sceneClassName === 'app'"
        />微信小程序-知链
      </div>
      <div class="module-box pt64 pb64 TA_left">
        <div class="module-text">
          <div class="title EC2 T4">轻松找到课堂入口 创造优质学习体验</div>
          <div
            v-if="$store.state.sceneClassName !== 'app'"
            class="title EC2 T4 mb24"
          ></div>
          <div class="EC3 T6 lz-desc2">
            微信首页任务栏等60+小程序入口，让10亿用户 <br />
            轻松发现你
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic5_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic5.jpg')"
            alt=""
          />
        </div>
      </div>

      <div class="module-box pt64 pb64 row-reverse TA_left">
        <div class="module-text">
          <div class="title EC2 T4">用户一处购买多处学习</div>
          <div
            v-if="$store.state.sceneClassName !== 'app'"
            class="title EC2 T4 mb24"
          ></div>
          <div class="EC3 T6 lz-desc2">
            公众号、小程序、微信群与知识店铺数 <br />
            据互联互通，流量变现快速高效
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic6_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic6.jpg')"
            alt=""
          />
        </div>
      </div>

      <div class="module-box pt64 pb64 TA_left">
        <div class="module-text">
          <div class="title EC2 T4">不止微信小程序课堂</div>
          <div class="title EC2 T4 mb24 title2">更多超级生态正在打通</div>
          <div class="EC3 T6 lz-desc2">
            覆盖微信、百度等多个超强流量生态， <br />
            帮助客户降低获客门槛，提高转化
          </div>
        </div>
        <div class="module-img lz-img">
          <img :src="require('@/assets/images/terminalPic7.png')" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'terminal',
  data() {
    return {};
  },
  components: {},
  mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss">
.app .terminal-mini {
  .module-box {
    padding: 0.8rem 0 1.28rem;
    .title {
      padding-top: 0;
      text-align: center;
      font-size: 0.32rem !important;
      font-weight: 600;
      margin-top: 0.48rem;
      line-height: 1.3;
    }
    .lz-desc2 {
      margin-top: 0.16rem;

      text-align: center;
    }
    .title2 {
      margin-top: 0;
    }
  }
  .lz-modules1 {
    .lz-title1 {
      background: #f6f9ff;
      padding-top: 0.8rem;
    }
    .module-box:nth-child(even) {
      background: #f6f9ff;
    }
    .module-box:nth-child(2) {
      padding-top: 1px;
    }
  }
}
</style>
